import { Injectable } from '@angular/core';
import { GLOBAL } from 'src/app/services/global';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class VentanillaService {
  public url: string;
  public identity;
  public token;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _http: HttpClient
  ) {
    this.url = GLOBAL.url;
  }


  getToken() {
    let token = localStorage.getItem('token');
    if (token !== 'undefined') {
        this.token = token;
    } else {
        this.token = null;
    }
    return this.token;
  }

  getPresolicitudesVentanilla(campoAbuscar=false): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    if(campoAbuscar){
      console.log('Buscar');
      return this._http.get(this.url + 'ventanilla/get/presolicitudes/'+campoAbuscar, { headers });
    }else{
      console.log('All');
      return this._http.get(this.url + 'ventanilla/get/presolicitudes', { headers });
    }
  }

  getUpaegsPorCampo(campo): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'ventanilla/get/upaegs/'+campo, { headers });
  }

  getApoyosForUpaeg(id_productor): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'ventanilla/get/apoyos/upaeg/'+id_productor, { headers });
  }






}
